module.exports = __webpack_public_path__ + "KhushiNileshPathak-1-0b42ecc4.png";